// ──────────────────────────────────────────────────────────────
//  Хуулийн заалт (key = 1-11,  key in object = 22.9.x)
// ──────────────────────────────────────────────────────────────
export const huuliData = {
  1: {
    key: '22.9.1',
    text:
      'ой, амьтан, ус зэрэг байгалийн баялаг хамгаалах, нөөцийг нэмэгдүүлэх, зохистой ашиглах, нөхөн сэргээх, агаар, ус, хөрсний бохирдлыг бууруулах, цөлжилтийг сааруулах',
    yam: [1, 2],
  },
  2: {
    key: '22.9.2',
    text:
      'ахмад настан, хөгжлийн бэрхшээлтэй иргэн, хүүхдийн асрамжийн үйлчилгээ, гэр бүлийн эрхийг хангах, хамгаалах, хөгжлийн бэрхшээлтэй иргэдэд зориулсан тохижуулгат орчин бүрдүүлэх, хүүхдийн тоглоомын талбай, зуслан, цэцэрлэгт хүрээлэн барьж байгуулах, ашиглах',
    yam: [3, 4, 5],
  },
  3: {
    key: '22.9.3',
    text:
      'соёлын өвийг хамгаалах, сэргээх, музей, номын сангийн үйл ажиллагаа болон хөгжим, кино, гар урлал, тайзны урлагийн бүтээл туурвих, тоглох, түгээх, соёлын бүтээлч үйлдвэрлэлийн цогцолбор барьж байгуулах, ашиглах',
    yam: [6, 1],
  },
  4: {
    key: '22.9.4',
    text:
      'нийтийн эзэмшлийн зам, талбай, цэцэрлэгт хүрээлэн барьж байгуулах, ашиглах, хамгаалах, тохижуулах, цэцэрлэгжүүлэх, нийтийн тээврийн хөгжлийг дэмжих',
    yam: [7, 1],
  },
  5: {
    key: '22.9.5',
    text:
      'давагдашгүй хүчин зүйл болон түүнтэй адилтгах бусад гамшгийн улмаас хохирол барагдуулах',
    yam: [8, 9],
  },
  6: {
    key: '22.9.6',
    text:
      'спортын барилга байгууламж барьж байгуулах, ашиглах, олимпын төрлийн тэмцээн зохион байгуулах, Монголын үндэсний олимпын хороо, Монголын үндэсний паралимпын хорооны бүртгэлтэй олимпын төрлийн спортын холбоо, түүнд бүртгэлтэй баг, мэргэжлийн тамирчин, дасгалжуулагчид олгосон санхүүгийн дэмжлэг',
    yam: [6],
  },
  7: {
    key: '22.9.7',
    text:
      'Монгол Улсын Засгийн газраас зарласан тэргүүлэх чиглэлээр гадаадын их, дээд сургууль, дотоодын магадлан итгэмжлэгдсэн их, дээд сургуульд суралцаж байгаа оюутан, мэргэжлийн болон техникийн боловсролын сургалтын байгууллагын суралцагчид олгосон сургалтын төлбөрийн тэтгэлэг',
    yam: [5],
  },
  8: {
    key: '22.9.8',
    text:
      'их, дээд сургууль, шинжлэх ухааны академид судалгаа, шинжилгээнд зориулсан тэтгэлэг',
    yam: [5],
  },
  9: {
    key: '22.9.9',
    text:
      'төрийн болон орон нутгийн өмчийн боловсрол, эрүүл мэндийн байгууллагын үйл ажиллагаа',
    yam: [5, 10],
  },
  10: {
    key: '22.9.10',
    text: 'Засгийн газрын тусгай сангийн үйл ажиллагаа',
    yam: [4, 2, 5],
  },
  11: {
    key: '22.9.11',
    text:
      'мэдээллийн технологийн үйлдвэрлэлийг дэмжих виртуал бүсэд бүртгэлтэй хуулийн этгээдийн хуульд заасан үйл ажиллагаа',
    yam: [4, 5],
  },
};